import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

const APP_NAME = 'Senciyo';

export function usePageTitle(): void {
  const matches = useMatches();

  useEffect(() => {
    const lastWithTitle = [...matches]
      .reverse()
      .find((m) => typeof (m.handle as { title?: string })?.title === 'string');

    const title = (lastWithTitle?.handle as { title?: string })?.title;
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
  }, [matches]);
}
